import React, { useEffect, useState, useRef } from 'react';
import {
    Container,
    Box,
    Avatar,
    Typography,
    Grid,
    TextField,
    Button,
    Paper,
    Divider,
    Stack,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    InputAdornment,
    IconButton,
    Snackbar,
} from '@mui/material';
import { Grid2 } from '@mui/material';
import Config from '../Config.json';
import axios from "axios";
import { useBookContext } from "../contexts/bookContext";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme, styled } from '@mui/material/styles';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CloseIcon from '@mui/icons-material/Close';

const PwdTextField = (props) => {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };
    return (
        <TextField
            type={showPassword ? 'text' : 'password'}
            slotProps={{
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label={
                                    showPassword ? 'hide the password' : 'display the password'
                                }
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                onMouseUp={handleMouseUpPassword}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            }}

            {...props}
        />
    )
}

const EnrollUser = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [name, setName] = useState('');
    const [userLevel, setUserLevel] = useState(0);
    const [password, setPassword] = useState('');
    const { userData, isLogin, updateUserInfo, actions } = useBookContext();
    const [courseUserId, setCourseUserId] = useState('');
    const [courseUserPw, setCourseUserPw] = useState('');
    const [newCourse, setNewCourse] = useState('');


    const textCourseNameRef = useRef(null);
    const courseUserIdRef = useRef(null);
    const courseUserPwRef = useRef(null);


    const [stateSnackBar, setStateSnackBar] = React.useState({
        openSnackBar: false,
        verticalSnackBar: 'bottom',
        horizontalSnackBar: 'center',
    });
    const { verticalSnackBar, horizontalSnackBar, openSnackBar } = stateSnackBar;
    const [messageSnackBar, setMessageSnackbar] = useState('');


    const handleSnackBarClose = () => {
        setStateSnackBar({ ...stateSnackBar, openSnackBar: false });
    };

    const showSnackBar = (msg) => {
        setMessageSnackbar(msg);
        setStateSnackBar({ ...stateSnackBar, openSnackBar: true })
    }


    useEffect(() => {
        actions.extendTime(userData);
//        console.log("userData :" + JSON.stringify(userData))
    }, [userData]);


    const handleSubmit = (event) => {
        event.preventDefault();
        // Handle login logic here (e.g., API call for authentication)
        console.log('register submitted:', { email, password });
        register();
    };


    const register = async () => {


/*
        if (!newCourse || newCourse.length < 1) {
            showSnackBar('원하는 골프장을 입력하세요');
            if (textCourseNameRef.current) {
                textCourseNameRef.current.focus();
            }
            return;
        }


        if (!courseUserId || courseUserId.length < 1) {
            showSnackBar('골프장 아이디를 입력하세요');
            if (courseUserIdRef.current) {
                courseUserIdRef.current.focus();
            }
            return;
        }

        if (!courseUserPw || courseUserPw.length < 1) {
            showSnackBar('골프장 비밀번호를 입력하세요');
            if (courseUserPwRef.current) {
                courseUserPwRef.current.focus();
            }
            return;
        }
*/
        try {

            const reqData = {};
            reqData.userEmail = email;
            reqData.userPhone = phone;
            reqData.userName = name;
            reqData.userPW = password;
            reqData.recommenderCode = userData.userPhone;
            reqData.userLevel = userLevel;
            reqData.unlimitUser = userData.unlimitSeller;

//            console.log("req data :" + JSON.stringify(userData))
//            console.log("req data :"+JSON.stringify(reqData))

            
            let response = await axios.post("/api/booking/Register", reqData);
            //            console.log("login result :" + JSON.stringify(response.data))
            if ((response.data.code === 0)) {
                showSnackBar('사용자 생성이 완료되었습니다');
                setEmail('');
                setPhone('')
                setName('');
                setPassword('');
                setUserLevel(0);

                console.log("enrollUser add new user success")
            } else if (response.data.code === 10) {
                showSnackBar('이미 있는 사용자입니다');
                
            }
        } catch (err) {
            showSnackBar('사용자 생성에 실패하였습니다');
            console.error(err);
        }

    }



    const addCourse = async () => {

        var selCourse = undefined;


        /*
                if (selectedCourse && selectedCourse.courseName == newCourse) {
                    selCourse = selectedCourse;
                } else {
                    selCourse = findExistCourse(newCourse);
                }
        */


        try {
            const reqData = {};

            reqData.userEmail = userData.userEmail;
            reqData.memberId = courseUserId;
            reqData.memberPw = courseUserPw;

            reqData.inputCourseName = newCourse;
            reqData.needMakeNew = 1;


            let response = await axios.post("/api/booking/AddMyCourse", reqData);
            if ((response.data.code === 0)) {
                let courseData = response.data.result;
                setCourseUserId('');
                setCourseUserPw('');
                setNewCourse('');

            } else {
                if (response.data.code === 100) {
                    showSnackBar('이미 등록된 골프장입니다');

                } else {
                    showSnackBar('골프장 등록에 실패하였습니다');
                }
            }
        } catch (err) {
            console.error(err);
            showSnackBar('골프장 등록에 실패하였습니다');

        }



    }


    const renderUserLevel = () => {
        if (!userData || !userData.userLevel) {
            return null;
        }

        if (userData.userLevel < 100) {
            return null;
        }


        return (
            <TextField
                margin="normal"
                required
                fullWidth
                id="userLevel"
                label="유저레벨"
                name="userLevel"
                value={userLevel}
                onChange={(e) => setUserLevel(e.target.value)}
            />

        )
    }


    const renderAddGolfCourse = () => {
        return null;

        return (
            <>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    label="원하는 골프장을 입력하세요"
                    value={newCourse}
                    inputRef={textCourseNameRef}
                    onChange={(e) => setNewCourse(e.target.value)}
                />

                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="userId"
                    label="골프장 아이디"
                    name="userId"
                    autoComplete="nickname"
                    value={courseUserId}
                    inputRef={courseUserIdRef}
                    onChange={(e) => setCourseUserId(e.target.value)}
                />
                <PwdTextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="골프장 비밀번호"
                    id="password"
                    autoComplete="current-password"
                    inputRef={courseUserPwRef}
                    value={courseUserPw}
                    onChange={(e) => setCourseUserPw(e.target.value)}
                />
            </>
        )
    }


    return (
        <Container component="main" maxWidth="xs">
            <Paper elevation={3} sx={{ marginTop: 10, padding: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography component="h1" variant="h5">
                    유저추가
                </Typography>

                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="이메일"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="phone"
                        label="핸드폰번호 (- 없이)"
                        name="phone"
                        autoComplete="phone"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="name"
                        label="이름"
                        name="name"
                        autoComplete="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <PwdTextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="패스워드"
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    {renderUserLevel()}
                    {renderAddGolfCourse()}
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        disabled={email.length > 0 && password.length > 0 && phone.length > 0 && name.length > 0 ? false : true}
                        sx={{ mt: 3, mb: 2 }}
                    >
                        유저추가
                    </Button>
                </Box>
            </Paper>
            <Snackbar
                anchorOrigin={{ vertical: verticalSnackBar, horizontal: horizontalSnackBar }}
                open={openSnackBar}
                onClose={handleSnackBarClose}
                message={messageSnackBar}
                key={verticalSnackBar + horizontalSnackBar}
                autoHideDuration={5000}
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.5 }}
                        onClick={handleSnackBarClose}
                    >
                        <CloseIcon />
                    </IconButton>
                }
            />

        </Container>
    );
}
export default EnrollUser;